import React, { useState, useEffect } from 'react';
import api from '../services/api';
import '../styles/Dashboard.css';
import '../styles/Ledger.css';

const UserDetailsModal = ({ user, onClose }) => {
  if (!user) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <img
              src={`https://ui-avatars.com/api/?name=${user.name}&background=random&size=64`}
              alt={user.name}
              style={{ width: '64px', height: '64px', borderRadius: '16px' }}
            />
            <div>
              <h3 style={{ fontSize: '20px', fontWeight: '700' }}>{user.name}</h3>
              <p style={{ color: 'var(--text-muted)' }}>{user.email}</p>
            </div>
          </div>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          <div className="detail-item">
            <span className="detail-label">Role</span>
            <span className="detail-value">{user.role}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Date of Installation</span>
            {/* <span className="detail-label">Joined Date</span> */}
            <span className="detail-value">{user.dateJoined}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Subscription</span>
            <span className="detail-value">{user.subscriptionStatus}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const DeleteModal = ({ isOpen, user, onClose, onConfirm, loading }) => {
  if (!isOpen || !user) return null;

  return (
    <div className="modal-overlay" onClick={() => !loading && onClose()}>
      <div className="modal-content" style={{ maxWidth: '400px', textAlign: 'center' }} onClick={e => e.stopPropagation()}>
        <div style={{ marginBottom: '24px' }}>
          <div style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            background: '#FFF0ED',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px'
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--error)" strokeWidth="2.5">
              <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M10 11v6M14 11v6" />
            </svg>
          </div>
          <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '8px' }}>Delete User</h3>
          <p style={{ color: 'var(--text-muted)', fontSize: '15px' }}>
            Are you sure you want to permanently delete <strong>{user.name}</strong>? This action cannot be undone.
          </p>
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            className="btn-support"
            style={{ flex: 1 }}
            onClick={onClose}
            disabled={loading}
          >
            No, Keep
          </button>
          <button
            className="btn-support"
            style={{ flex: 1, background: 'var(--error)', color: 'white' }}
            onClick={() => onConfirm(user)}
            disabled={loading}
          >
            {loading ? <div className="button-spinner" /> : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

const DisconnectModal = ({ isOpen, user, onClose, onConfirm, loading }) => {
  if (!isOpen || !user) return null;

  return (
    <div
      className="modal-overlay"
      onClick={() => !loading && onClose()}
    >
      <div
        className="modal-content"
        style={{ maxWidth: '400px', textAlign: 'center' }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ marginBottom: '24px' }}>
          <div style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            background: '#F4F4F4',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px'
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#6F767E" strokeWidth="2.5">
              <path d="M18.36 6.64a9 9 0 1 1-12.73 0M12 2v10" />
            </svg>
          </div>
          <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '8px' }}>Disconnect Account</h3>
          <p style={{ color: 'var(--text-muted)', fontSize: '15px' }}>
            Are you sure you want to disconnect all linked accounts for <strong>{user.name}</strong>?
          </p>
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            className="btn-support"
            style={{ flex: 1 }}
            onClick={onClose}
            disabled={loading}
          >
            No, Keep
          </button>

          <button
            className="btn-support"
            style={{ flex: 1, background: '#1A1D1F', color: 'white' }}
            onClick={() => onConfirm(user)}
            disabled={loading}
          >
            {loading ? <div className="button-spinner" /> : 'Disconnect'}
          </button>
        </div>
      </div>
    </div>
  );
};

const UserRow = ({ user, onView, onDelete, onDisconnect }) => (
  <tr className="clickable-row" onClick={() => onView(user)}>
    <td className="user-cell">
      <div className="user-avatar-mini">{user.name.charAt(0)}</div>
      <span>{user.name}</span>
    </td>

    <td>{user.dateOfDownload}</td>

    <td>
      <span className={`status-chip ${user.plaidStatus === 'Connected' ? 'completed' : 'delayed'}`}>
        {user.plaidStatus}
      </span>
    </td>

    <td>
      <span className={`status-chip ${user.subscriptionStatus === 'Active' ? 'on-going' : 'delayed'}`}>
        {user.subscriptionStatus}
      </span>
    </td>

    <td>
      <div className="action-btn-list">
        <button
          className="btn-list-action"
          title="View Details"
          onClick={(e) => { e.stopPropagation(); onView(user); }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        </button>

        <button
          className="btn-list-action"
          title={user.plaidStatus === 'Disconnected' ? "Already Disconnected" : "Disconnect Account"}
          onClick={(e) => {
            e.stopPropagation();
            if (user.plaidStatus !== 'Disconnected') onDisconnect(user);
          }}
          disabled={user.plaidStatus === 'Disconnected'}
          style={{ opacity: user.plaidStatus === 'Disconnected' ? 0.4 : 1, cursor: user.plaidStatus === 'Disconnected' ? 'not-allowed' : 'pointer' }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M18.36 6.64a9 9 0 1 1-12.73 0M12 2v10" />
          </svg>
        </button>

        <button
          className="btn-list-action"
          title="Delete User"
          onClick={(e) => { e.stopPropagation(); onDelete(user); }}
          style={{ color: 'var(--error)' }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M10 11v6M14 11v6" />
          </svg>
        </button>
      </div>
    </td>
  </tr>
);

const Users = ({ onViewUserFinance }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [userToDelete, setUserToDelete] = useState(null);
  const [userToDisconnect, setUserToDisconnect] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [disconnectLoading, setDisconnectLoading] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await api.get('/admin-management/users');

      const formatted = (res.data?.users || []).map(u => ({
        id: u.id,
        name: `${u.firstName} ${u.lastName}`,
        email: u.email,
        role: u.role,
        dateOfDownload: new Date(u.createdAt).toLocaleDateString('en-US'),
        plaidStatus: u.plaidStatus ? 'Connected' : 'Disconnected',
        subscriptionStatus: u.subscriptionStatus === 'active' ? 'Active' : 'Inactive'
      }));

      setUsers(formatted);
    } catch (err) {
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        localStorage.clear();
        window.location.href = '/login';
        return;
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteUser = async (user) => {
    try {
      setDeleteLoading(true);
      await api.delete(`/admin-management/users/${user.id}`);
      setUsers(prev => prev.filter(u => u.id !== user.id));
      setUserToDelete(null);
    } catch (err) {
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        localStorage.clear();
        window.location.href = '/login';
        return;
      }
      console.error('Failed to delete user:', err);
      alert(err.response?.data?.error || 'Failed to delete user');
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleDisconnectUser = async (user) => {
    try {
      setDisconnectLoading(true);
      await api.post(`/admin-management/users/${user.id}/disconnect-plaid`);
      setUsers(prev =>
        prev.map(u =>
          u.id === user.id ? { ...u, plaidStatus: 'Disconnected' } : u
        )
      );
      setUserToDisconnect(null);
    } catch (err) {
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        localStorage.clear();
        window.location.href = '/login';
        return;
      }
      console.error(err);
    } finally {
      setDisconnectLoading(false);
    }
  };

  return (
    <>
      <div className="ledger-container">
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', flexWrap: 'wrap', gap: '20px', marginBottom: '24px' }}>
          <div className="overview-section">
            <div className="overview-header">
              <p style={{ color: 'var(--text-muted)', fontSize: '14px', fontWeight: '500', margin: 0 }}>Manage and organize application users</p>
            </div>
          </div>

          <div className="search-container visible-search">
            <svg className="search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              type="text"
              placeholder="Search by name or email..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {loading ? (
          <p>Loading users...</p>
        ) : (
          <div className="ledger-table-wrapper">
            <table className="ledger-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Date of Installation</th>
                  <th>Plaid Status</th>
                  <th>Subscription</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {(() => {
                  const filteredUsers = users.filter(u =>
                    u.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    u.email.toLowerCase().includes(searchTerm.toLowerCase())
                  );

                  if (filteredUsers.length === 0) {
                    return (
                      <tr>
                        <td colSpan="5" style={{ textAlign: 'center', padding: '40px', color: 'var(--text-muted)' }}>
                          No users found.
                        </td>
                      </tr>
                    );
                  }

                  return filteredUsers.map((user) => (
                    <UserRow
                      key={user.id}
                      user={user}
                      onView={onViewUserFinance}
                      onDelete={setUserToDelete}
                      onDisconnect={setUserToDisconnect}
                    />
                  ));
                })()}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <DeleteModal
        isOpen={!!userToDelete}
        user={userToDelete}
        onClose={() => setUserToDelete(null)}
        onConfirm={handleDeleteUser}
        loading={deleteLoading}
      />

      <DisconnectModal
        isOpen={!!userToDisconnect}
        user={userToDisconnect}
        onClose={() => setUserToDisconnect(null)}
        onConfirm={handleDisconnectUser}
        loading={disconnectLoading}
      />
    </>
  );
};

export default Users;